import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import { DesbloquearUsuarioService } from '../../Service/desbloquear-usuarios.service';
import { UserService } from '../../../services/user.service';
import { SweetAlertService } from 'src/app/services/sweet-alert.service';
import { AnalyticsTagService } from 'src/app/services/analytics-tag.service';
declare var $: any;

@Component({
    selector: 'app-desbloquear-usuarios',
    templateUrl: './desbloquear-usuarios.component.html',
    styleUrls: ['./desbloquear-usuarios.component.scss'],
    providers: [DesbloquearUsuarioService],
    standalone: false
})
export class DesbloquearUsuariosComponent implements OnInit {
  buscarUsuaForm: UntypedFormGroup;
  documentos: any[] = [];
  idCliente: any;
  totalPaginas: number = 1;
  paginaActual: number = 0;
  public listaUsuarios: any[] = [];
  public datosTabla: boolean = false;

  constructor(
    private desbloquearUsuariosService: DesbloquearUsuarioService,
    private formBuilder: UntypedFormBuilder,
    private user: UserService,
    private _sweetAlert:SweetAlertService,
    private _analyticsTag: AnalyticsTagService
  ) {
    this.buscarUsuaForm = this.formBuilder.group({
      idTipoDocIdentidad_NeoTipoDocIdentidad: null,
      numeroDocumento: null,
      pagina: 1
    });
  }

  ngOnInit(){
    this.getDocumentos();
    this.idCliente = this.user.getUser().idCliente;
    this.datosTabla = false;
  }

  getDocumentos(){
    this.desbloquearUsuariosService.getTipoDocumentos().subscribe((data:any)=>{
      this.documentos = data.filter(
        (documento) => documento.idTipoDocIdentidad != 1 && documento.idTipoDocIdentidad != 4 && documento.idTipoDocIdentidad != 6
      );
    });
  }

  trackBuscar(){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Buscar',
      ctaSection: 'desbloquear-usuarios-if',
      ctaComponent: 'desbloquear-usuarios-if',
      ctaElementId: 'btn-buscar',
      hu: '8337',
    });
  }

  botonBuscar(){
    if (this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value != null) {
      this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad')
        .setValue(Number(this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value));
    }
    
    if (this.buscarUsuaForm.get('numeroDocumento').value == '') {     
      this.buscarUsuaForm.get('numeroDocumento').setValue(null);
    }
    
    if(this.idCliente==0){
      this.idCliente=null;
    }
    const body:any = {
      idTipoDocIdentidad_NeoTipoDocIdentidad: this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value,
      numeroDocumento: this.buscarUsuaForm.get('numeroDocumento').value,
      idCliente: this.idCliente,
      isGetBloqueados: 1,
      pagina: this.buscarUsuaForm.get('pagina').value
    }

    this.desbloquearUsuariosService.getBuscarUsuarios(body)
      .subscribe((response: any) => {
        this.listaUsuarios = response.data;
        if (this.listaUsuarios == undefined) {
          this.datosTabla = false;
          this.mensaje();
        } else {
          this.datosTabla = true;
          this.totalPaginas = response.paginasTotales;
          this.paginaActual = response.paginaActual;
        }
      });
  }

  selectPage(pageNumber: number){
    this.buscarUsuaForm.get('pagina').setValue(pageNumber);
    this.botonBuscar();
  }

  desbloquear(i){
    this._analyticsTag.trackCtaClick({
      ctaLabel: 'Desbloquear',
      ctaSection: 'desbloquear-usuarios-if',
      ctaComponent: 'desbloquear-usuarios-if',
      ctaElementId: 'btn-desbloquear',
      hu: '8337',
    });
    var idUsuario =this.listaUsuarios[i].idUsuario;
    this.desbloquearUsuariosService.getDesbloquearUsuario(idUsuario,this.user.getUser().idUsuario)
    .subscribe((data:any)=>{
      this._sweetAlert.successModal('Cambios Guardados').then((result)=>{
        if(result.isConfirmed){
          this.ngOnInit();
        }
      });
      // $('#desbloquearModal').modal('show');
    });   
  }

  mensaje(){
    this._sweetAlert.infoModal('No se encontraron usuarios con los criterios seleccionados',false);
    // $('#mensajeModal').modal('show');    
  }

  validateNumber(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  validateDocument(event: any) {
    if (this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 5 ||
    this.buscarUsuaForm.get('idTipoDocIdentidad_NeoTipoDocIdentidad').value == 3) {
      const pattern = /[A-Z0-9]/;
      let inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        event.preventDefault();
      }
    } else {
      this.validateNumber(event);
    }
  }
  validarSelect() {
    this.buscarUsuaForm.get('numeroDocumento').setValue('');
  }
}
